import { render, staticRenderFns } from "./vehicleprofile.vue?vue&type=template&id=581ab1fe&scoped=true"
import script from "./vehicleprofile.js?vue&type=script&lang=js&external"
export * from "./vehicleprofile.js?vue&type=script&lang=js&external"
import style0 from "./vehicleprofile.vue?vue&type=style&index=0&id=581ab1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ab1fe",
  null
  
)

export default component.exports